import AdminUserDecorator from "./AdminUserDecorator";
import CompanyDecorator from "./CompanyDecorator";
import CompanyMemberDecorator from "./CompanyMemberDecorator";

export default class AdminUserFullDecorator extends AdminUserDecorator {
  constructor({ name, ...data }) {
    super({
      ...data,
      companies: data.companies.map((x) => new CompanyDecorator(x)),
      company_members: data.company_members.map((x) => new CompanyMemberDecorator(x)),
    });
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/AdminUserFullDecorator.js